module.exports = __webpack_public_path__ + "img/20190515152923201903132901.bf4eda33.jpg";